import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getAdminByIdApi } from "@app/apis/UsersManagement/adminsApis";
import type { AdminUserDetailApiResponse } from "@app/apis/UsersManagement/types";
import { useAuthStore } from "@store/useAuthStore";
import { getCookie } from "@app/actions";
const fetchUser = async (): Promise<AdminUserDetailApiResponse> => {
  const userId = localStorage.getItem("user_id") || (await getCookie("user_id"));
  if (!userId) {
    throw new Error("User ID not found");
  }
  const admin = await getAdminByIdApi(userId);
  if (!admin) {
    throw new Error("User data not found");
  }
  useAuthStore.getState().setAuth({
    user: admin
  });
  return admin;
};
export const useUser = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["user"],
      queryFn: fetchUser,
      staleTime: 300000,
      gcTime: 600000,
      retry: 2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: user,
    isLoading,
    error,
    refetch
  } = useQuery(t0);
  let t1;
  if ($[1] !== error || $[2] !== isLoading || $[3] !== refetch || $[4] !== user) {
    t1 = {
      user,
      isLoading,
      error,
      refetch
    };
    $[1] = error;
    $[2] = isLoading;
    $[3] = refetch;
    $[4] = user;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};